import React, { Component } from 'react';
import RightArrow from 'material-ui/svg-icons/hardware/keyboard-arrow-right';
import IconButton from 'material-ui/IconButton';
import pure from 'recompose/pure';

const styles = {
  mediumIcon: {
    width: 48,
    height: 48,
  },
  medium: {
    width: 96,
    height: 96,
  },
};

class nextArrow extends Component {
  render() {
    const { currentSlide, slideCount, ...filteredProps } = this.props;
    return (
      <div {...filteredProps}>
        <IconButton iconStyle={styles.mediumIcon} style={styles.medium}>
          <RightArrow color="rgb(169, 169, 169)" />
        </IconButton>
      </div>
    );
  }
}

export default pure(nextArrow);
